import React from 'react';

function Footer() {
  return (
    <footer>&copy; JD Nafziger, 2023</footer>
    )
}

export default Footer;
